<div class="navline-container">
  <div class="left-navline-buttons">
    @for (element of navLine.getVisibleElements('left'); track element) {
      <dt-navline-element
        [label]="element.getLabel()"
        [link]="element.getRouterLink()"
        [icon]="element.getIcon()"
        [iconPosition]="element.getIconPosition()"
        [tooltip]="element.getTooltip()"
        [color]="element.getButtonColor()"
        [disabled]="element.isDisabled()"
        [cypressId]="element.getCypressId()"
        (buttonClick)="element.handleClick($event)"
      >
      </dt-navline-element>
    }
  </div>

  @if (navLine.getVisibleElements().length > 0) {
    <div class="middle-navline-buttons">
      <div class="wrap-helper"></div>
      <div class="navline-elements">
        @for (element of navLine.getVisibleElements(); track element) {
          <dt-navline-element
            [label]="element.getLabel()"
            [link]="element.getRouterLink()"
            [icon]="element.getIcon()"
            [iconPosition]="element.getIconPosition()"
            [tooltip]="element.getTooltip()"
            [color]="element.getButtonColor()"
            [disabled]="element.isDisabled()"
            [cypressId]="element.getCypressId()"
            (buttonClick)="element.handleClick($event)"
          >
          </dt-navline-element>
        }
      </div>
      <button
        mat-raised-button
        color="accent"
        (click)="navMenuTrigger.openMenu()"
        class="nav-menu-button"
        #navMenuButton="dtElementRef"
        dtElementRef
      >
        &mldr;
        <div class="nav-menu-trigger" [matMenuTriggerFor]="menu" #navMenuTrigger="matMenuTrigger"></div>
      </button>
      <mat-menu #menu="matMenu" class="dt-nav-menu">
        @for (element of navLine.getVisibleElements(); track element) {
          <button
            mat-menu-item
            [routerLink]="element.getRouterLink()"
            [matTooltip]="element.getTooltip()"
            [matTooltipShowDelay]="500"
            [disabled]="element.isDisabled()"
            [attr.data-cy]="'navline-element-' + element.getCypressId()"
            (click)="element.handleClick(navMenuButton)"
          >
            @if (element.getIcon()) {
              <mat-icon>{{ element.getIcon() }}</mat-icon>
            }
            <span>{{ element.getLabel() }}</span>
          </button>
        }
      </mat-menu>
    </div>
  }

  <div class="right-navline-buttons">
    @for (element of navLine.getVisibleElements('right'); track element) {
      <dt-navline-element
        [label]="element.getLabel()"
        [link]="element.getRouterLink()"
        [icon]="element.getIcon()"
        [iconPosition]="element.getIconPosition()"
        [tooltip]="element.getTooltip()"
        [color]="element.getButtonColor()"
        [disabled]="element.isDisabled()"
        [cypressId]="element.getCypressId()"
        (buttonClick)="element.handleClick($event)"
      >
      </dt-navline-element>
    }
  </div>
</div>
